import Header from "../header/Header";
import Link from 'next/link';
import Image from 'next/image';
import { IProject } from "../../../models/Project";
import Img from "../images/Img";

export type ProjectCardProps = {
  project: IProject
};

const ProjectCard: React.FC<ProjectCardProps> = (props) => {
  const { project } = props;
  return (
    <>
      <div className="shadow-xl mb-4 flex flex-col rounded-xl dark:bg-theme-dark-light dark:shadow-none">
        <div className="relative">
          <Link href={`/proyectos/${project.slug}`}>
            <a>
              <Img
                image={project.bannerImage}
                cloudinaryTransformation={{}}
                width={640}
                height={360}
                className="object-cover rounded-lg aspect-w-16 aspect-h-9"
              />
            </a>
          </Link>
          <div className="absolute top-2 left-2 rounded-xl">
            <div className="bg-highlight-yellow rounded-2xl py-1 px-4 text-white text-xs">{project.programmingLevel.name}</div>
          </div>
        </div>
        <div className="p-4 flex flex-col justify-between flex-1">
          <div>
            <Link href={`/proyectos/${project.slug}`}>
              <a className="">
                <Header as="h5" className="font-bold dark:text-highlight-yellow text-lg mb-2 hover:opacity-50">{project.title}</Header>
              </a>
            </Link>
          </div>
          <p className="text-sm text-gray-400 dark:text-white mb-4 flex-1">{project.description}</p>
          <div className="flex flex-row flex-wrap">
            {project.branches?.map((branch, idx) => (
              <div key={idx}>
                <div className="text-primary text-xs mr-2">#{branch.name.replace(' ', '')}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectCard;
